import React from 'react';

export default ({width, height, title, onClick, bgColor,style,textStyle,bdColor, ...props}) => {
    return(
        <div style={{
                width: width, 
                height: height, 
                display: 'flex',
                justifyContent: 'center', 
                alignItems: 'center',
                borderRadius: 8,
                border:`1px solid ${bdColor}` ,
                backgroundColor: bgColor,
                cursor: 'pointer'
            }}
            onClick={() => typeof onClick === 'function' ? onClick() : null }
        >
            <span style={textStyle}>{title}</span>

        </div>
    )
}